import {Component, OnInit} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {TenantConfigService} from '@rsp/shared/services/tenant-config.service';
import {ImageUrlBuilderService} from '@rsp/shared/services/image-url-builder.service';
import {GeolokationDTO, ProductionSiteDTO} from '@rsp/models/dto/tenants-details.dto';
import {environment} from '@env/environment';
import {UserTrackingService} from '@rsp/shared/services/user-tracking.service';


@Component({
  selector: 'rsp-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss']
})
export class LandingComponent implements OnInit {

  landingh: string; // headline
  landingt: string; // text

  expand = true;
  timeout = 300000; // delay till intro collapse

  public regions: number[] = [];
  public markers: Array<number[]> = [];
  public mappoints: Array<number[]> = [];

  public url;

  constructor(
    private titleService: Title,
    public tenant: TenantConfigService,
    private userTracker: UserTrackingService,
    public imageUrlBuilder: ImageUrlBuilderService) {
    this.url = environment.baseUrlApi;
  }

  ngOnInit() {
    if (this.tenant && this.tenant.getInfo()) {
      this.initMap();

      this.landingh = this.tenant.getInfo().landingHeaderText;
      this.landingt = this.tenant.getInfo().landingDetailText;

      this.titleService.setTitle(this.tenant.getInfo().name + ' | Mein Strom');
    }


    this.userTracker.trackPageView();

    setTimeout(() => {
      if (this.expand) {
        this.expand = false;
      }
    }, this.timeout);

  }

  private initMap() {
    this.regions.push(+this.tenant.getInfo().longitude, +this.tenant.getInfo().latitude);

    Promise.all([this.tenant.getProductionSites(), this.tenant.getGeolocations()]).then((dtos) => {
      this.markers = (<ProductionSiteDTO[]>dtos[0]).map((powerplant) => {
        return [+powerplant.longitude, +powerplant.latitude, powerplant.energyType];
      });

      this.mappoints = (<GeolokationDTO[]>dtos[1]).map((geo) => {
        return [+geo.longitude, +geo.latitude, geo.type];
      });
    });
  }

}
